module.exports = __webpack_public_path__ + "img/7.9a52b138.png";